<template>
  <!-- Main content -->
    <!-- Info boxes -->
  <div class="row">
    <div class="box">
      <div class="box-header with-border">
        <div class="col-xs-12">
          <div class="box-header">
            <div class="col-xs-12 text-right pull-right">
              <div class="col-sm-6 text-left">
                <div class="form-group form-inline w-auto" v-if="brandBrief.length > 1 && $route.name !== 'storeInfo'">
                  <select class="form-control h-38" v-model="brandSelect">
                    <option value="0" v-if="roleType !== 10">== 品牌 ==</option>
                    <option v-for="brand in brandBrief" :value="brand.value">
                      {{brand.label}}
                    </option>
                  </select>
                </div>
                <div class="form-group form-inline w-auto" v-if="roleType === 99">
                  <select class="form-control h-38" v-model="storeSelect">
                    <option value="0">== 門市 ==</option>
                    <option v-for="store in storeBrief" :value="store.value">
                      {{store.label}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-sm-6 text-right pull-right">
                <div class="form-group input-group time-box pull-right">
                  <date-time-picker :date="menuTime.start" :option="dateoption" :limit="startLimit"></date-time-picker>
                  <date-time-picker :date="menuTime.end" :option="dateoption" :limit="endLimit"></date-time-picker>
                  <!--<input type="text" class="form-control time-picker" id="start-box" placeholder="起始時間">-->
                  <!--<input type="text" class="form-control time-picker" id="end-box" placeholder="結束時間">-->
                  <span class="input-group-btn">
                  <button class="btn btn-default submit-btn btn-search" type="button"
                          id="search2" style="height: 72px" @click="getSearchPosition()">
                    <i class="fa fa-search"></i>
                  </button>
                </span>
                </div>
              </div>
            </div>
            <div class="col-xs-12">
              <div :id="mapName"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /.content -->
</template>

<script>
/* eslint-disable no-new */
import moment from 'moment'
import { mapGetters } from 'vuex'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
// googleMap
var map, markerCluster
var markers = []
// var markers
export default {
  components: {
    'date-time-picker': datetimePicker
  },
  data () {
    return {
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: 0,
      storeSelect: 0,
      positionList: [],
      // google map
      mapName: 'map',
      // date
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: moment().add(1, 'days').format('YYYY-MM-DD')
        },
        week: {
          time: moment().add(-1, 'weeks').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          to: moment().format('YYYY-MM-DD')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          to: moment().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
        }
      ],
      weekLimit: [
        {
          type: 'fromto',
          to: moment().add(-1, 'weeks').day(7).format('YYYY-MM-DD')
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    }
  },
  created () {
    var date = new Date()
    var y = date.getFullYear()
    var m = date.getMonth()
    var firstDay = new Date(y, m, 1)
    this.menuTime.start.time = moment(firstDay).add(-1, 'month').format('YYYY-MM-DD')
    this.fixedH()
    let roleType = parseInt(this.getRoleType, 10)
    this.roleType = roleType
    if (roleType === 99) {
      this.getBrandBrief()
    } else if (roleType === 30) this.getBrandBrief()
    else if (roleType === 10) this.getBrandBrief()
  },
  methods: {
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          var brandIds = ''
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
            brandIds = brandIds + bList[i].brand_id + ','
          }
          brandIds = brandIds.slice(0, -1)
          if (self.roleType === 30) self.brandSelect = brandIds
          if (self.roleType !== 99) self.getStoreBrief(brandIds)
          else self.getSearchPosition()
        }
      })
    },
    getStoreBrief (brandId) {
      this.storeBrief = []
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          var storeIds = ''
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            storeIds = storeIds + sList[i].store_id + ','
          }
          storeIds = storeIds.slice(0, -1)
          if (self.roleType === 10) self.storeSelect = storeIds
          self.getSearchPosition()
        }
      })
    },
    getSearchPosition () {
      this.positionList = []
      var self = this
      var url
      var brandSelect = parseInt(this.brandSelect, 10)
      var storeSelect = parseInt(this.storeSelect, 10)
      if (this.roleType === 99) {
        if (brandSelect === 0) url = '/shopper/searchPosition'
        else if (storeSelect === 0) url = '/brand/' + this.brandSelect + '/shopperSearchPosition'
        else url = '/store/' + this.storeSelect + '/shopperSearchPosition'
      } else if (this.roleType === 30) {
        if (storeSelect === 0) url = '/brand/' + this.brandSelect + '/shopperSearchPosition'
        else url = '/store/' + this.storeSelect + '/shopperSearchPosition'
      } else url = '/store/' + this.storeSelect + '/shopperSearchPosition'
      var data = {
        start_time: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      }
      url = url + '?start_time=' + data.start_time + '&end_time=' + data.end_time
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var positionList = response.data.position_list
          for (var i = 0; i < positionList.length; i++) {
            var pos = positionList[i].split(',')
            var o = {
              lat: Number(pos[0]),
              lng: Number(pos[1])
            }
            self.positionList.push(o)
          }
          self.setMap()
          // self.addMarkerWithTimeout()
        }
      })
    },
    initMap () {
      map = new window.google.maps.Map(document.getElementById(this.mapName), {
        zoom: 9,
        center: {lat: 23, lng: 121}
      })
    },
    clearMarkers () {
      /*
      for (var i = 0; i < markers.length; i++) {
        markers[i].setMap(null)
      }
      */
      if (markerCluster) markerCluster.clearMarkers(markers)
      markers = []
    },
    addMarker (position) {
      /*
      var shape = {
        coords: [1, 1, 1, 20, 18, 20, 18, 1],
        type: 'poly'
      }
      markers.push(new window.google.maps.Marker({
        position: {lat: position.lat, lng: position.lng},
        map: map,
        shape: shape
      }))
      */
      markerCluster = new window.MarkerClusterer(map, markers, {imagePath: 'https://panel.nidin.shop/static/img/m'})
    },
    setMap () {
      this.clearMarkers()
      var averageLat = 0
      var averageLng = 0
      var totalLat = 0
      var totalLng = 0
      for (var i = 0; i < this.positionList.length; i++) {
        var beach = this.positionList[i]
        totalLat = totalLat + beach.lat
        totalLng = totalLng + beach.lng
        // this.addMarker(beach)
      }
      markers = this.positionList.map(function (location, i) {
        return new window.google.maps.Marker({
          position: location
        })
      })
      this.addMarker()
      if (this.positionList.length) {
        averageLat = totalLat / this.positionList.length
        averageLng = totalLng / this.positionList.length
        map.setCenter({lat: averageLat, lng: averageLng})
      }
    }
  },
  mounted () {
    this.initMap()
  },
  watch: {
    'menuTime.end.time' () {
      var lastDay = moment(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay
      this.startLimit = [
        {
          type: 'fromto',
          to: lastDay
        }
      ]
    },
    'menuTime.start.time' () {
      var lastDay = moment(this.menuTime.start.time).add('60', 'days')
      if (lastDay < moment()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD')
      else this.menuTime.end.time = moment().format('YYYY-MM-DD')
      this.endLimit = [
        {
          type: 'fromto',
          from: moment(this.menuTime.start.time).subtract(1, 'days'),
          to: moment(this.menuTime.end.time).add(1, 'days')
        }
      ]
    },
    brandSelect () {
      this.storeSelect = 0
      if (this.brandSelect !== 0 && this.brandSelect !== '0') {
        this.getStoreBrief(this.brandSelect)
      } else {
        this.getSearchPosition()
      }
    },
    storeSelect () {
      this.getSearchPosition()
    }
  }
}
</script>
<style lang="sass" scope>
@media screen and (max-width: 767px)
  .box-title
    text-align: center
    width: 100%
</style>



// WEBPACK FOOTER //
// SearchMapTemp.vue?24446a22